import React from 'react'
import PropTypes from "prop-types"
import styled from 'styled-components'

import BackgroundImage from 'gatsby-background-image'

const Link = styled.a`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
`

const Container = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0 !important;
  `

const Background = ({className, url,  background, target}) => (
  <Container>
      <BackgroundImage Tag="section"
                       className={className}
                       fluid={background}
      >
        <Link href={url} target={target} />
      </BackgroundImage>
  </Container>
)

const SliderItem = styled(Background)`
  border-radius: 0.5em;
  width: 100%;
  background-color: #CECECE;
  background-position: center center;
  background-repeat: no-repeat;
  position: relative;
  min-height: 430px;
  @media (min-width: 770px){
    max-width: 740px;
    min-height: 380px;
  }

  @media (max-width: 765px){
    max-width: 650px;
    min-height: 310px;
  }
  @media (max-width: 573px){
    max-width: 490px;
    min-height: 260px;
  }
  @media (max-width: 480px){
    max-width: 420px;
    min-height: 200px;
  }

  @media (max-width: 377px){
    max-width: 350px;
    min-height: 170px;
  }
  
  
  &:before{
    opacity: 1 !important;
  }

  `

SliderItem.propTypes = {
  url: PropTypes.string,
  background: PropTypes.any,
}
export default SliderItem;